export interface RuntimeHealth {
  runtime?: string;
  device?: string;
  acceptance_eligible?: boolean;
}

export const isFakeRuntimeHealth = (health: RuntimeHealth | null | undefined): boolean =>
  health?.runtime === "fake" || health?.device === "fake";
